import { IName, IPath } from "./types";
import { isEmpty, isNumber } from "lodash";

/**
 * Build a string that works as the path parameter for lodash.get()
 * @param paths
 * @returns
 */
export const buildPath = (...paths: Array<IPath | IName | number>): IPath =>
  paths.reduce((p, v) => `${p}${isNumber(v) ? `[${v}]` : `${isEmpty(p) ? "" : "."}${v}`}`, "") as IPath;
